module.exports = __webpack_public_path__ + "img/agility.d99065f.svg";